<div class="format-view-shared_section-header format-view-shared_extra-margin-top">
  <span class="format-view-shared_section-title">{{ 'FORMAT_VIEW_DIALOG.EXTENSION_SECTION' | translate }}</span>
</div>
<div class="format-view-shared_field">
  <span class="format-view-shared_field-label">{{ 'FORMAT_VIEW_DIALOG.EXTENSION_LABEL' | translate }}</span>
  <mat-form-field celum-form-field data-test-file-extensions-field class="format-view-shared_field--bg-white" size="medium" [reserveHintSpace]="true">
    <input
      type="text"
      data-test-file-extensions
      matInput
      [formControl]="searchTerm"
      [placeholder]="'FORMAT_VIEW_DIALOG.EXTENSION_PLACEHOLDER' | translate"
      [matAutocomplete]="auto" />
    <celum-icon [configuration]="arrowIcon" matSuffix></celum-icon>
    @if (formatFormService.formatForm.controls.fileExtension.errors?.['required']) {
      <mat-error data-test-file-extensions-error-required>{{ 'VALIDATION.REQUIRED' | translate }}</mat-error>
    }
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" class="file-extensions_select-panel">
    <mat-option data-test-indeterminate-option class="file-extensions_option file-extensions_option--batch-action">
      <celum-checkbox-item
        orientation="row"
        class="file-extensions_batch-text"
        [checked]="formatFormService.formatForm.controls.fileExtension.value.length === specStore.fileExtensions().length"
        [indeterminate]="
          formatFormService.formatForm.controls.fileExtension.value.length !== specStore.fileExtensions().length &&
          formatFormService.formatForm.controls.fileExtension.value.length > 0
        "
        [text]="('COMMON.SELECT_ALL' | translate) + ':'"
        [showToolTip]="false"
        (click)="$event.stopPropagation()"
        (selectionChanged)="checkFileExtensions()" />
    </mat-option>
    @for (extensionGroup of filteredExtensions(); track extensionGroup.name) {
      <span class="file-extensions_group-name">{{ extensionGroup.name | translate }}</span>
      @for (extension of extensionGroup.extensions; track extension) {
        <mat-option class="file-extensions_option">
          <celum-checkbox-item
            orientation="row"
            [checked]="formatFormService.formatForm.controls.fileExtension?.value.includes(extension)"
            [showToolTip]="false"
            [text]="extension"
            (click)="$event.stopPropagation()"
            (selectionChanged)="formatFormService.toggleFileExtension(extension, $event.checked)" />
        </mat-option>
      }
    }
  </mat-autocomplete>
  <celum-chip-set
    class="file-extensions_chips"
    [clearAllButtonText]="'FORMAT_VIEW_DIALOG.CLEAR_ALL_EXTENSIONS'"
    [showClearAll]="formatFormService.formatForm.controls.fileExtension.value.length > 0"
    (clearAllClicked)="formatFormService.clearFileExtensions()">
    @for (extension of formatFormService.formatForm.controls.fileExtension.value; track extension) {
      <celum-chip [text]="extension" (remove)="formatFormService.removeFileExtension(extension)"></celum-chip>
    }
  </celum-chip-set>
</div>
